// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"93dfe837","393":"3507d2a3","395":"5e49c6dd","434":"e2fc59a3","504":"8e187fea","767":"2dc0fe9c","787":"95b0ecac"}[chunkId] + ".chunk.js";
};